import { Avatar, IconButton, List, ListItem, ListItemIcon, ListItemText, makeStyles } from '@material-ui/core';
import { AccountCircle, GetApp } from '@material-ui/icons';
import React, { useState } from 'react';
import { useGoogleLogin, useGoogleLogout } from 'react-google-login';
import { CloseBtn } from './Button';

const useStyles = makeStyles((theme)=>({

    listItem: {
        marginTop: '2vh',
    },
    icon : {
        color : '#fe752f',
        fontSize : '1.5rem !important',
        "& .MuiSvgIcon-root" : {
            fontSize : '1.5rem !important',
            color : '#e5e7eb',
        },
        "& :hover" : {
            backgroundColor : 'transparent',
            color : '#fe752f',
            border : 'none',
        },
    },
    svg : {
        width: '1.5em !important',
        height : '1.5em !important',
        color : '#e5e7eb !important',
        '& .MuiIcon-root' : {
            width : '1.5em !important',
            height : '1.5em importamt'
        }
    }

}));

const clientId = "1046785123269-gg6ob1gdpql3nfdd9h9ispclce9b8ipj.apps.googleusercontent.com";
export default function NavMenu({ display, visible, handleDownloadClick }) {
    
    const classes = useStyles();
    
    const [signStatus, setSign] = useState((localStorage.getItem("auth"))?true:false);

    const onSuccess = (res) => {
        console.log("Login succ",res)
        let obj = res.profileObj;
        obj.ttl = (+new Date + 1296000);
        localStorage.setItem("auth",JSON.stringify(obj));
        setSign(true)
    }
    const onFailure = (res) => {
        console.log("Login fail",res)
        localStorage.removeItem("auth")
    }
    const onLogoutSuccess = (suc) => {
        console.log("logout success",suc);
        localStorage.removeItem("auth");
        setSign(false)
    }
    
    const { signIn } = useGoogleLogin({
        onSuccess,
        clientId,
        onFailure,
        cookiePolicy:'single_host_origin'
    })
    
    const { signOut } = useGoogleLogout({
    onLogoutSuccess,
    clientId,
    })

    return(
        <div id="nav" style={display ?{display:"block"}:{display:"none"}}>
            <List>
                <ListItem classes = {{ root : classes.listItem }} onClick={()=>{ !signStatus?signIn():signOut() }} >
                    <ListItemIcon classses={{ root : classes.svg }} >
                        { signStatus?
                            <Avatar 
                                alt="signed-in"
                                // ref={anchorRef}
                                // aria-controls={open ? 'menu-list-grow' : undefined}
                                aria-haspopup="true"
                                src={JSON.parse(localStorage.getItem("auth")).imageUrl || null}
                                // onClick={handleToggle}
                                classes={{ root : classes.avatar }}
                                >
                                    <AccountCircle />
                                </Avatar> : 
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" className="GSvg" ><path d="M12.24 10.285V14.4h6.806c-.275 1.765-2.056 5.174-6.806 5.174-4.095 0-7.439-3.389-7.439-7.574s3.345-7.574 7.439-7.574c2.33 0 3.891.989 4.785 1.849l3.254-3.138C18.189 1.186 15.479 0 12.24 0c-6.635 0-12 5.365-12 12s5.365 12 12 12c6.926 0 11.52-4.869 11.52-11.726 0-.788-.085-1.39-.189-1.989H12.24z"></path></svg>}
                    </ListItemIcon>
                    <ListItemText primary={signStatus?"Sign out":"Sign in"} />
                </ListItem>
                <ListItem classes = {{ root : classes.listItem }} >
                    <ListItemText primary="GitHub" />
                </ListItem>
                <ListItem disabled={!visible}  onClick={handleDownloadClick} button>
                    <ListItemText primary="Download PWA" />
                    <IconButton disabled={!visible} onClick={handleDownloadClick}  classes={{ root : classes.icon }} >
                        <GetApp />
                    </IconButton>
                </ListItem>
                <ListItem>
                    <ListItemText primary="How it works ?" />
                </ListItem>
            </List>
        </div>
    )
}